import * as React from 'react';
import * as I18n from 'i18n-js';
import UrlHelpers, { isMobileNativeDevice } from '../../shared/url_helpers';
import { withUserContext, IUserContext } from '@reverbdotcom/commons/dist/components/user_context_provider';

import * as appCallout from '../../../../images/homepage/app-callout.png';
import * as appleBadgeDe from '../../../../images/app-store-badges/apple-app-store-de.svg';
import * as googleBadgeDe from '../../../../images/app-store-badges/google-play-store-de.svg';
import * as appleBadgeEn from '../../../../images/app-store-badges/apple-app-store-en.svg';
import * as googleBadgeEn from '../../../../images/app-store-badges/google-play-store-en.svg';
import * as appleBadgeEs from '../../../../images/app-store-badges/apple-app-store-es.svg';
import * as googleBadgeEs from '../../../../images/app-store-badges/google-play-store-es.svg';
import * as appleBadgeFr from '../../../../images/app-store-badges/apple-app-store-fr.svg';
import * as googleBadgeFr from '../../../../images/app-store-badges/google-play-store-fr.svg';
import * as appleBadgeIt from '../../../../images/app-store-badges/apple-app-store-it.svg';
import * as googleBadgeIt from '../../../../images/app-store-badges/google-play-store-it.svg';
import * as appleBadgeJa from '../../../../images/app-store-badges/apple-app-store-ja.svg';
import * as googleBadgeJa from '../../../../images/app-store-badges/google-play-store-ja.svg';

const LOCALE_TO_APPLE_BADGE = {
  de: appleBadgeDe,
  en: appleBadgeEn,
  es: appleBadgeEs,
  fr: appleBadgeFr,
  it: appleBadgeIt,
  ja: appleBadgeJa,
};

const LOCALE_TO_GOOGLE_BADGE = {
  de: googleBadgeDe,
  en: googleBadgeEn,
  es: googleBadgeEs,
  fr: googleBadgeFr,
  it: googleBadgeIt,
  ja: googleBadgeJa,
};

export function DownloadAppCallout(props: IUserContext) {
  const userLocale = props.user.locale && props.user.locale.slice(0, 2);
  const appleBackgroundImage = `url('${LOCALE_TO_APPLE_BADGE[userLocale] || appleBadgeEn}')`;
  const googleBackgroundImage = `url('${LOCALE_TO_GOOGLE_BADGE[userLocale] || googleBadgeEn}')`;

  function renderAppleAppStoreBadge() {
    return (
      <a
        className="download-app__link"
        href={`${UrlHelpers.appleAppStorePath}?pt=2069466&ct=logged-out-homepage-app-badge&mt=8`}
        style={{ backgroundImage: appleBackgroundImage }}
      >
        <span className="download-app__link-alt">
          {I18n.t('discovery.getTheApp.iosAlt')}
        </span>
      </a>
    );
  }

  function renderGooglePlayStoreBadge() {
    return (
      <a
        className="download-app__link"
        href={
          `${UrlHelpers.googlePlayStorePath}&utm_source=reverb_website&utm_campaign=feed_app_download&utm_medium=website_banner&utm_content=logged-out-homepage-app-badge}`}
        style={{ backgroundImage: googleBackgroundImage }}
      >
        <span className="download-app__link-alt">
          {I18n.t('discovery.getTheApp.androidAlt')}
        </span>
      </a>
    );
  }

  return (
    <div className="download-app">
      {!isMobileNativeDevice(props.user.deviceName) &&
        <div className="download-app__container">
          <div className="download-app__image-container">
            <img
              className="download-app__image"
              src={appCallout} alt="Reverb app on phone"
            />
          </div>
          <div className="download-app__content">
            <h3 className="download-app__title">
              {I18n.t('discovery.getTheApp.header')}
            </h3>
            <p className="download-app__subtitle">
              {I18n.t('discovery.getTheApp.subtitle')}
            </p>
            <div className="download-app__links">
              {renderAppleAppStoreBadge()}
              {renderGooglePlayStoreBadge()}
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default withUserContext(DownloadAppCallout);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/homepage/download_app_callout.tsx